var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-svg",
    viewBox: "0 0 65 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-spoon-fork",
    "data-name": "Icon metro-spoon-fork",
    d: "M16.559,1.928c-7.193,0-13.024,6.8-13.024,15.195,0,7.185,4.275,13.205,10.02,14.788L11.4,67.057a4.043,4.043,0,0,0,4.076,4.333h2.171a4.043,4.043,0,0,0,4.076-4.333L19.564,31.911c5.745-1.583,10.02-7.6,10.02-14.788C29.583,8.731,23.752,1.928,16.559,1.928Zm43.776,0L56.717,23.635H54L52.195,1.928H50.386L48.577,23.635H45.864L42.246,1.928H40.437V30.147a2.171,2.171,0,0,0,2.171,2.171h5.653l-2.131,34.74A4.043,4.043,0,0,0,50.2,71.391h2.171a4.043,4.043,0,0,0,4.076-4.333L54.32,32.318h5.653a2.171,2.171,0,0,0,2.171-2.171V1.928Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDine);
export default __webpack_public_path__ + "static/media/dine.11e20f3260989b6879a5af1275cffe34.svg";
export { ForwardRef as ReactComponent };